module.exports = __webpack_public_path__ + "fonts/CircularStd-BoldItalic.705bbdf2.woff";